import { useUrlSearchParams } from '@vueuse/core';

const params = useUrlSearchParams('history');

export default function useUrlParams() {
  return params;
}
